<template>
  <div class="MarkerAttributeEditor" :class="{'eidtMode':!readonly, 'editView':isEditor}" v-if="isShow">
    <span class="dialog-header" @mousedown="onmousedown">
      <span class="title">{{ markerName||'图文信息' }}</span>
      <Icon class="close" type="big" name="el-icon-close" @click.native="onClose"></Icon>
    </span>
    <div class="content-edit" v-if="isEditor">
      <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editor"
          :defaultConfig="toolbarConfig"
          :mode="mode"
      />
      <Editor
          style="height: 260px; overflow-y: hidden;"
          v-model="html"
          :defaultConfig="editorConfig"
          :mode="mode"
          @onCreated="onCreated"
      />
    </div>
    <div class="content-view" v-else>
      <div v-html="html"></div>
    </div>
    <div slot="footer" class="footer" v-if="!readonly">
      <div v-if="isEditor">
        <el-button @click="onCancelEdit">取消</el-button>
        <el-button type="primary" @click="onSave" :loading="loading">保存</el-button>
      </div>
      <div v-else>
        <el-button @click="onClose">关闭</el-button>
        <el-button type="primary" @click="isEditor=true">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
// import { DomEditor } from '@wangeditor/editor'
import { richSnippets } from '@/api/marker'

export default Vue.extend({
  name: 'MarkerAttributeEditor',
  components: { Editor, Toolbar },
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      markerName: '',
      isShow: false,
      isEditor: false,
      html_bak: '',
      html: '',
      loading: false,

      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadImage', 'uploadVideo']
      },
      editorConfig: { placeholder: '请输入内容...' },
      mode: 'default' // or 'simple'
    }
  },
  watch: {
    isShow (val) {
      this.$store.dispatch('setDrawState', val)
    }
  },
  mounted () {

  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    show ({ markerId, markerName, html, isEditor = false }) {
      this.markerId = markerId
      this.markerName = markerName
      this.html = html || '<p>请输入内容...</p>'
      this.html_bak = this.html
      this.isEditor = isEditor
      this.isShow = true
    },
    clear () {
      this.html_bak = ''
      this.html = ''
      this.isEditor = false
    },
    onClose () {
      this.clear()
      this.isShow = false
      this.$emit('close')
    },
    onCancelEdit () {
      this.html = this.html_bak
      this.isEditor = false
    },
    async onSave () {
      this.loading = true
      const res = await richSnippets({
        id: this.markerId,
        richSnippets: this.html
      })
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.markerId)
      if (marker) {
        marker.setPropertyValue('richSnippets', this.html)
      }
      this.$Message('success', res.msg || '操作成功')
      this.html_bak = this.html
      this.isEditor = false
      this.loading = false
      this.onClose()
    },
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    // 拖动相关事件
    onmousedown (e) {
      const disX = e.clientX - this.$el.offsetLeft
      const disY = e.clientY - this.$el.offsetTop

      const self = this
      document.onmousemove = function (e) {
        // 计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY
        // 移动当前元素
        self.$el.style.left = l + 'px'
        self.$el.style.top = t + 'px'
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss">
.MarkerAttributeEditor {
  position: absolute;
  top: 60px;
  right: 300px;
  width: 440px;
  height: 310px;
  background: #3D3E40;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.33);
  border-radius: 6px;
  z-index: 100;
  &.eidtMode{
    height: 340px;
  }
  &.editView{
    height: 500px;
  }
  .lt{
    position: absolute;
    top: 0;
    left: 0;
  }
  .lb {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .rt{
    position: absolute;
    top: 0;
    right: 0;
  }
  .rb{
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .dialog-header{
    height: 32px;
    line-height: 32px;
    margin-top: 5px;
    .title{
      margin-left: 12px;
      color: #fff;
      width: 380px;
      height: 22px;
      line-height: 32px;
      display: inline-block;
      overflow: hidden;
      text-align: left;
    }
    .value{
      color: $font-colorf;
      margin-right: 30px;
    }
    .close{
      float: right;
      margin-right: 1px;
      color: #fff;
    }
  }
  .top{
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #2CF7F8;
      line-height: 50px;
      margin-left: 30px;
    }
    .close {
      width: 16px;
      height: 16px;
      margin-right: 30px;
      cursor: pointer;
    }
  }
  .content-edit{
    // width: 858px;
    // height: 581px;
    margin-bottom: 5px;
  }
  .content-view{
    width: 420px;
    height: 260PX;
    padding: 10px;
    background: unset;
    border: 0.01rem solid rgba(255, 255, 255, 0.06);
    border-radius: 10px;
    overflow: auto;
    margin: 5px auto;
    h1, h2, h3, h4, h5, h6{
      color: #2CF7F8;
    }
    h1{
      font-size: 2em;
    }
    p{
      color: #fff;
    }
  }
}
</style>
